import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { DesignTemplate, DesignTemplateSearchParam } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DesignTemplateService {

  private path = '/design_templates';

  constructor(private http: AlloxApiService) { }

  public search(param?: DesignTemplateSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toFlattenURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new DesignTemplate(obj))),
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new DesignTemplate(obj))
    );
  }

  public post(item: DesignTemplate) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: DesignTemplate) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: DesignTemplate[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }

}
